
import * as constants from "../constants/CONSTANT";

const ExternalChatBotflowApi = {
  async fetchChatbotFlows(businessNumber, accessToken) {
    const url = `${constants.API_BASE_URL}/api/whatsapp/externalchatbotflow?business_number=${businessNumber}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  },

  async createChatbotFlow(flowData, accessToken) {
    const url = `${constants.API_BASE_URL}/api/whatsapp/externalchatbotflow`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(flowData),
    });
    return await response.json();
  },

  async updateChatbotFlow(flowId, flowData, accessToken) {
    const url = `${constants.API_BASE_URL}/api/whatsapp/externalchatbotflow/${flowId}`;
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(flowData),
    });
    return await response.json();
  },

  async deleteChatbotFlow(flowId, accessToken) {

    const url = `${constants.API_BASE_URL}/api/whatsapp/externalchatbotflow/${flowId}`;
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  },

  async getActiveChatbotFlows(businessNumber, accessToken) {
    const url = `${constants.API_BASE_URL}/api/whatsapp/externalchatbotflow/active?business_number=${businessNumber}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  },
  async createFile(formData, accessToken) {
    const url = `${constants.API_BASE_URL}/api/whatsapp/externalchatbotflow/files`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        // Do not manually set 'Content-Type' when using FormData
      },

      body: formData,
    });
    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Failed to upload file: ${response.status} - ${error}`);
    }

    return await response.json();
  },


  async updateFlowStatus(flowId, status, accessToken) {
    const url = `${constants.API_BASE_URL}/api/whatsapp/externalchatbotflow/${flowId}/status`;
    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ status }),
    });
    return await response.json();
  },
};

export default ExternalChatBotflowApi;
